import {OK, UNPROCESSABLE_ENTITY} from '../../utils';
import * as Sentry from "@sentry/browser";

const state = {
    user: null,
    apiStatus: null,
    apiResponse: null
};

const getters = {
    check: state => !!state.user,
    user: state => state.user ?? null,
    username: state => state.user ? state.user.name : '',
};

const mutations = {
    setUser(state, user) {
        state.user = user;
    },
    setApiStatus(state, status) {
        state.apiStatus = status
    },
    setResponse(state, response) {
        state.apiResponse = response
    }
};

const actions = {
    async register(context, data) {
        const response = axios.post('/member/register'.data);
        context.commit('setUser', response.data);
    },
    async login(context, data) {
        context.commit('setApiStatus', null);
        const response = await axios.post('/member/login', data)
            .catch(err => err.response || err);

        // バリデーションエラー取得のためレスポンスデータを保存
        context.commit('setResponse', response.data);

        if (response.status === OK) {
            context.commit('setApiStatus', true);
            context.commit('setUser', response.data);

            // Sentryにログインユーザ情報を設定
            Sentry.configureScope((scope) => {
                Sentry.setUser(response.data);
            });

            return false;
        }

        context.commit('setApiStatus', false);
        context.commit('error/setCode', response.status, {root: true});
    },
    async logout(context, data) {
        const response = await axios.post('/member/logout');
        context.commit('setUser', null);
    },
    async currentUser(context) {
        let user = null;
        const response = await axios.get('/member/user')
            .then(response => {
                user = response.data;

                // Sentryにログインユーザ情報を設定
                Sentry.configureScope((scope) => {
                    Sentry.setUser(response.data);
                });
            })
            .catch(error => {
                const {data, status, statusText} = error.response;
                if (status !== 401) {
                    this.errors = {};
                    this.$store.state.error.code = error.response.status;
                }
            });
        // const user = response.data || null;
        context.commit('setUser', user);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
